import React from 'react';

export const MenuSistema = ({sistema, onClickSistema}) =>
  <div className="col col-sm-3 col-md-2 col-lg-2 sistemacard" onClick={(e) => onClickSistema(e, sistema)}>
      <div className="card">
        <div className="text-center imagensistema" >
          {sistema.bnrImagen && <img src={`data:image/png;base64,${sistema.bnrImagen}`} alt={sistema.nomEtiqueta}/>}
        </div>
        <div className="overview-box-title" >
          <h4 className="text-center titulosistemas">{sistema.nomEtiqueta}</h4>
        </div>
      </div>
  </div>;
